/**
 * Generates a storage key for the delivery address based on cart ID
 * @param {string} cartId - The unique cart identifier
 * @returns {string} The storage key
 */
export const getDeliveryAddressKey = (cartId) => {
  return `delivery_address_${cartId}`;
};

/**
 * Saves delivery address to local storage
 * @param {string} cartId - The unique cart identifier
 * @param {Object} address - The delivery address to save
 */
export const saveDeliveryAddress = (cartId, address) => {
  if (!cartId || !address) return;
  const key = getDeliveryAddressKey(cartId);
  localStorage.setItem(key, JSON.stringify(address));
};

/**
 * Retrieves delivery address from local storage
 * @param {string} cartId - The unique cart identifier
 * @returns {Object|null} The stored address or null if not found
 */
export const getDeliveryAddress = (cartId) => {
  if (!cartId) return null;
  const key = getDeliveryAddressKey(cartId);
  const storedAddress = localStorage.getItem(key);
  if (!storedAddress) return null;
  
  try {
    return JSON.parse(storedAddress);
  } catch (error) {
    return null;
  }
};

/**
 * Clears the stored delivery address
 * @param {string} cartId - The unique cart identifier
 */
export const clearDeliveryAddress = (cartId) => {
  if (!cartId) return;
  const key = getDeliveryAddressKey(cartId);
  localStorage.removeItem(key);
}; 